import React, { useRef } from 'react';
import { usePageWidth } from '../../../navigation/pageWidth';
import { usePageFitWidth } from './pageFitWidth';

/**
 * The page area of the Forge, Eval, Archon and Lurker shells. It carries the matched page's
 * width, which forge-theme.css reads to cap chart dashboards, short lists and forms, and to fit
 * table pages to their widest table.
 */
export const ShellMain: React.FC<{
  isResizing: boolean;
  marginLeft: number;
  children: React.ReactNode;
}> = ({ isResizing, marginLeft, children }) => {
  const pageWidth = usePageWidth();
  const mainRef = useRef<HTMLElement>(null);
  usePageFitWidth(mainRef, pageWidth === 'fit');
  return (
    <main
      ref={mainRef}
      className={`forge-main-content ${isResizing ? 'sidebar-resizing' : ''}`}
      data-page-width={pageWidth}
      style={{ marginLeft }}
    >
      {children}
    </main>
  );
};
